<template>
  <div class="home">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="itemContainer">
      <div v-if="isInspectionMainte">
        <InspectionMainte></InspectionMainte>
      </div>
      <div v-else-if="inspectionFlag">
        <InspectionAfter v-bind:car="car" v-bind:Manufacturer="Manufacturer" v-bind:detail="detail" v-bind:ssInfo="ssInfo"  v-bind:tsId="tsId" v-bind:nativeData="nativeData" v-bind:profileInfo="profileInfo" v-bind:versionData="versionData"></InspectionAfter>
      </div>
      <div v-else>
        <InspectionBefore v-bind:car="car" v-bind:ssInfo="ssInfo" v-bind:profileInfo="profileInfo" v-bind:tsId="tsId" v-bind:nativeData="nativeData" v-bind:detail="detail" v-bind:versionData="versionData"></InspectionBefore>
      </div>
      <input id="tsid" type="hidden" name="tsid" v-bind:value="$route.query.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="$route.query.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="$route.query.otoken">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionData.osVersion">
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inspection from '@/store/Api/inspection'
import car from '@/store/Api/car'
import profileApi from '@/store/Api/Common/profile'
import ssApi from '@/store/Api/Common/ss'
import manufacturersApi from '@/store/Api/manufacturers'
import InspectionMainte from '@/views/v2/InspectionMainte'
import InspectionBefore from '@/views/v2/InspectionBefore'
import InspectionAfter from '@/views/v2/InspectionAfter'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading'
import appVerApi from '@/store/Api/Common/appVer'

export default {
  data () {
    return {
      loading: true,
      tsId: 0,
      inspectionID: 0,
      inspectionFlag: true,
      carFlag: true,
      profileInfo: [],
      ssInfo: [],
      Manufacturer: {},
      coupon: {
        name: '',
        shortDescription: '利用クーポン無し',
        usableStartAt: '',
        usableEndAt: '',
        description: ''
      },
      isInspectionMainte: false
    }
  },
  methods: {
    ...mapActions('INSPECTION', [
      'setInspection',
      'setDetail'
    ]),
    ...mapActions('CAR', [
      'setCar'
    ]),
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('INSPECTION', [
      'inspection',
      'detail'
    ]),
    ...mapGetters('CAR', [
      'car'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // inspection(予約)データ取得
    await inspection.get(this.$route.query.tsid).then(res => {
      this.setInspection(res.data)
    }).catch(e => {
      console.log('inspection-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.inspection.inspections.length !== 0) this.setDetail((await inspection.getDetail(this.inspection.inspections[0].id)).data)
    if (this.detail[0].id !== '') {
      // 車名（メーカーを取得する）
      await manufacturersApi.getDetail(this.detail[0].inspection_estimate.manufacturer_id).then(res => {
        this.Manufacturer = res.data.manufacturer
      }).catch(e => {
        console.log('manufactuer-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    } else {
      this.inspectionFlag = false
    }
    // SS情報マスタ取得。
    // 予約がある場合
    if (this.inspectionFlag) {
      console.log('********* inspection_estimate.ss_code')
      console.log(this.detail[0].inspection_estimate.ss_code)
      await ssApi.get(this.detail[0].inspection_estimate.ss_code).then(res => {
        this.setSsInfo(res.data.body.ss_info)
      }).catch(e => {
        console.log('ss-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    // 予約がない場合
    } else {
      // ベストMYSSが存在している場合
      if (this.profileInfo.best_myss.length !== 0) {
        await ssApi.get(this.profileInfo.best_myss.code).then(res => {
          this.setSsInfo(res.data.body.ss_info)
        }).catch(e => {
          console.log('ss-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }
    }
    // car(車検証)データ取得
    if (!(await car.get(this.nativeData.tsid)).data.car[0]) this.carFlag = false
    if (this.carFlag === true) {
      this.setCar((await car.get(this.nativeData.tsid)).data.car[0])
      // // // 車検満了日
      this.car.expiryGengo = 0
      // // 初度登録年月
      this.car.firstRegistrationGengo = 0
      this.car.oil_exchanged = true
      // // TODO
      this.car.coupon = this.coupon
      this.car.coupon_id = ''
      this.car.coupon_fee = 0
      this.car.bestmy_ss_id = ''
      this.car.bestmy_ss_prefecture = ''
      this.car.bestmy_ss_factory_type_flag = ''
    }
    // イベントトラッキング
    // 予約がある場合
    if (this.inspectionFlag) {
      if (this.detail[0].id !== '') {
        // 申し込み
        if (this.detail[0].status_code === 1) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Mosikomi' })
        }
        // 日程確定
        if (this.detail[0].status_code === 2) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Nitteikakutei' })
        }
        // お預かり
        if (this.detail[0].status_code === 3) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Azukarityu' })
        }
        // 車検完了
        if (this.detail[0].status_code === 4) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Kanryo' })
        }
        // 支払い完了（現金払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 2) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Cash' })
        }
        // 支払い完了（クレジット払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 1) {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Credit' })
        }
      }
    // 予約がない場合
    } else {
      if (this.profileInfo.best_myss.length !== 0) {
        // 車検対応店舗
        if (this.ssInfo.komikomi_flag === 1) {
          this.nativePVset('CARCARE')
        // 車検非対応店舗
        } else {
          this.nativeEVENTSet('CarCare', 'CARCARE', 'PAGEVIEW', { shakenStatus: 'Noservice' })
        }
      }
    }

    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      if (res.data.webviewMaintenance.inspection) {
        this.isInspectionMainte = true
      }
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    InspectionMainte,
    InspectionBefore,
    InspectionAfter,
    Loading
  }
}
</script>
